<script setup></script>
<template>
  <svg
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    class="fill-current icon-base"
  >
    <path
      d="M7.75 0C3.46978 0 0 3.46978 0 7.75C0 12.0302 3.46978 15.5 7.75 15.5C12.0302 15.5 15.5 12.0302 15.5 7.75C15.5 3.46978 12.0302 0 7.75 0ZM7.75 1.5C11.2041 1.5 14 4.29534 14 7.75C14 11.2041 11.2047 14 7.75 14C4.29588 14 1.5 11.2047 1.5 7.75C1.5 4.29588 4.29534 1.5 7.75 1.5ZM12.1314 5.57084L11.4271 4.86091C11.2813 4.71387 11.0438 4.71291 10.8968 4.85878L6.47956 9.24053L4.61106 7.35687C4.46522 7.20984 4.22778 7.20887 4.08075 7.35472L3.37078 8.05897C3.22375 8.20481 3.22278 8.44225 3.36866 8.58931L6.20556 11.4492C6.35141 11.5962 6.58884 11.5972 6.73588 11.4513L12.1293 6.10119C12.2763 5.95531 12.2772 5.71788 12.1314 5.57084Z"
    />
  </svg>
</template>
